import { Component, Input } from '@angular/core';

@Component({
  selector: 'incidents-statistics-item',
  templateUrl: './incidents-statistics-item.component.html',
  styleUrls: ['incidents-statistics.component.scss'],
})
export class IncidentsStacisticsItemComponent {
  @Input() description: string;
  @Input() amount: string;
  @Input() colour: string;
}
